import { Component, EventEmitter, Input, type OnInit, Output, ViewChild } from '@angular/core'
import { SharedService } from '../../../../../services/shared.service'
import {
  VehicleNotificationsDTO, VehicleNotificationsService
} from '../../../../../services/vehicle-notifications.service'
import { CptGoogleTagmanagerService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'

import { NgxGlideComponent, NgxGlideModule } from 'ngx-glide'
import { NGXLogger } from 'ngx-logger'
import { type VehicleDTOExtended } from '../../../../../services/vehicles.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { NgxMaskPipe } from 'ngx-mask'
import { VehicleWarningIndicatorComponent } from '../../../../vehicle-details/vehicle-warning-indicator/vehicle-warning-indicator.component'
interface VehicleExtendedNotifications extends VehicleDTOExtended {
  vehicleNotifications?: VehicleNotificationsDTO
}
@Component({
  selector: 'customer-portal-app-notifications',
  standalone: true,
  templateUrl: './notifications.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    NgxMaskPipe,
    VehicleWarningIndicatorComponent
  ]
})
export class NotificationsComponent implements OnInit {
  @Input()
  set setNotifications (notifications: VehicleNotificationsDTO) {
    this.notifications = this.sharedService.deepCopy(notifications)
    this.setVehicleNotifications()
  }

  get setNotifications (): VehicleNotificationsDTO {
    return this.notifications
  }

  notifications: VehicleNotificationsDTO

  @Input()
  set setVehicles (vehicles: VehicleExtendedNotifications[]) {
    this.vehicles = this.sharedService.deepCopy(vehicles)
    this.setVehicleNotifications()
  }

  get setVehicles (): VehicleExtendedNotifications[] {
    return this.vehicles
  }

  vehicles: VehicleExtendedNotifications[]

  @Input() loadingNotifications = true

  vehicleNotifications

  @Output() action = new EventEmitter()

  licensePlateMask

  @ViewChild('NotificationsComponent_ngxGlide')
    NotificationsComponent_ngxGlide!: NgxGlideComponent

  firstVehicle
  notificationsKey
  constructor (
    public sharedService: SharedService,
    private readonly logger: NGXLogger,
    private readonly vehicleNotificationsService: VehicleNotificationsService,
    private readonly cptGtmService: CptGoogleTagmanagerService
  ) {}

  ngOnInit (): void {
    this.licensePlateMask = this.sharedService.setLicensePlateMask()
  }

  setVehicleNotifications (): void {
    if (
      this.notifications?.vehicleNotifications?.[0] != null &&
      this.vehicles?.[0] != null &&
      this.vehicleNotifications?.[0] == null
    ) {
      this.vehicles.forEach(vehicle => {
        vehicle.vehicleNotifications =
          this.vehicleNotificationsService.setVehicleNotifications(
            this.notifications,
            vehicle.vin
          )
      })
      this.vehicleNotifications = this.vehicles.filter(vehicle => {
        return vehicle.vehicleNotifications
      })
      this.updateItems()
      this.firstVehicle = this.sharedService.deepCopy(
        this.vehicleNotifications[0]
      )
    } else {
      if (this.vehicles?.[0] != null) {
        this.firstVehicle = this.sharedService.deepCopy(this.vehicles[0])
      }
    }

    this.setTranslateKey()
  }

  updateItems (): void {
    setTimeout(() => {
      if (this.NotificationsComponent_ngxGlide != null) {
        try {
          this.NotificationsComponent_ngxGlide.recreate()
        } catch (error) {
          this.logger.log(error)
        }
      }
    })
  }

  setTranslateKey (): void {
    const length = this.vehicleNotifications?.length ?? 0

    switch (length) {
      case 1:
        this.notificationsKey =
          'customerPortal.customer-portal.vehicles_need_attention.1'
        break
      default:
        this.notificationsKey = 'shared.vehicle-attention'
        break
    }
  }

  sendContentModulesCTAData (contentModuleLabel: string): void {
    this.cptGtmService.sendContentModulesData(
      'CTA',
      'Click',
      this.sharedService.translateLink(contentModuleLabel) ?? '',
      'CTA',
      this.sharedService.translateLink(contentModuleLabel) ?? ''
    )
  }

  sendContentModulesSliderData (
    side: string,
    contentModuleLabel: string,
    galleryName: string
  ): void {
    this.cptGtmService.sendContentModulesData(
      'Gallery',
      side,
      this.sharedService.translateLink(contentModuleLabel) ?? '',
      `Gallery|(${galleryName})`,
      side
    )
  }
}
